(() => {
  const initCarousel = (scope = document) => {
    scope.querySelectorAll('[data-clicklife-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;
      carousel.dataset.carouselInitialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
      const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
      if (slides.length < 2 || slides.length !== dots.length) return;
      let active = 0;
      let timer;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => { slide.hidden = position !== active; });
        dots.forEach((dot, position) => {
          if (position === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (!reducedMotion.matches && !document.hidden) timer = setInterval(() => show(active + 1), 6500);
      };
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(active + (event.key === 'ArrowRight' ? 1 : -1));
        dots[active].focus();
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      reducedMotion.addEventListener('change', start);
      show(0);
      start();
    });
  };

  const initPage = (scope = document) => {
    scope.querySelectorAll('.clicklife-page__content .clicklife-page-hero').forEach((legacyHero) => legacyHero.remove());
  };

  const initProduct = (scope = document) => {
    scope.querySelectorAll('[data-clicklife-product]').forEach((section) => {
      if (section.dataset.clicklifeInitialized === 'true') return;
      section.dataset.clicklifeInitialized = 'true';

      const mainImage = section.querySelector('[data-gallery-main]');
      section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumb.dataset.imageAlt || '';
          section.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const productForm = section.querySelector('.clicklife-product__form');
      const stickyCart = section.querySelector('[data-sticky-cart]');
      const updateStickyCart = () => {
        if (!productForm || !stickyCart) return;
        stickyCart.classList.toggle('is-visible', productForm.getBoundingClientRect().bottom < 0);
      };
      updateStickyCart();
      addEventListener('scroll', updateStickyCart, { passive: true });
      addEventListener('resize', updateStickyCart);

      const variantSelect = section.querySelector('[data-variant-select]');
      if (!variantSelect) return;
      const price = section.querySelector('[data-product-price]');
      const stock = section.querySelector('[data-product-stock]');
      const submit = section.querySelector('[data-add-to-cart]');
      const stickySubmit = section.querySelector('[data-sticky-submit]');
      const stickyPrice = section.querySelector('[data-sticky-price]');

      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const compare = option.dataset.comparePrice;
        price.innerHTML = `<span class="clicklife-product__price-current">${option.dataset.price}</span>${compare ? `<s>${compare}</s><span class="clicklife-sale-badge">セール</span>` : ''}`;
        stickyPrice.textContent = option.dataset.price;
        stock.textContent = available ? '在庫あり' : '売り切れ';
        stock.classList.toggle('is-sold-out', !available);
        [submit, stickySubmit].forEach((button) => {
          if (!button) return;
          button.disabled = !available;
          button.textContent = available ? 'カートに追加' : '売り切れ';
        });
      });
    });
  };

  const init = (scope = document) => {
    initCarousel(scope);
    initPage(scope);
    initProduct(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
